module.exports = __webpack_public_path__ + "fonts/Anjoman-FaNum-SuperHeavy.59712c5.woff";